import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { ProjectChecklist } from '@portal-core/project-checklists/models/project-checklist.model';

@Component({
  selector: 'mc-project-checklist-overview',
  templateUrl: './project-checklist-overview.component.html',
  styleUrls: ['./project-checklist-overview.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectChecklistOverviewComponent {
  @Input() checklist: ProjectChecklist;

  tabIndex: number = 0;
  maxTabIndex: number = 2;

  changeTabClicked(newTab: number) {
    this.tabIndex = newTab;
  }
}
